<template>
  <span class="menu-mobile-button" @click="handlerOpenMenu">
    <svg><use xlink:href="#svg-burger"></use></svg>
  </span>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
import useModalMenu from '@use/useModalMenu/useModalMenu';

const MenuMobile = defineAsyncComponent(() => import('@components/Menu/MenuMobile/MenuMobile.vue'));

const modalMenu = useModalMenu();

const handlerOpenMenu = () => {
  modalMenu.show(MenuMobile);
};
</script>

<style lang="scss" scoped>
.menu-mobile-button {
  display: block;
  cursor: pointer;
  svg {
    width: 24px;
    height: 24px;
  }
}
</style>
